module.exports = __webpack_public_path__ + "static/media/develop.45ea1adc.png";